export default __webpack_public_path__ + "static/media/mb10.d505828c.JPG";